/**
 * R7: Ghost seed demotion [AUTO-APPLY, confidence=1.0]
 *
 * For each seed in audit_report.layers.L5_coverage.ghost_seeds:
 *   count = nodes in seed WHERE matched_wp_post_id IS NOT NULL
 *   if count === 0: UPDATE thematic_seeds SET status='pending_production'
 *
 * Ghost seed = seed z 0% matched WP posts. Ale R7 jeszcze dodatkowo weryfikuje
 * że faktycznie 0 nodów tego seeda ma matched (na wypadek gdyby audit_report
 * był stale). Seed ze status='active' → 'pending_production' oznacza że nie
 * produkujemy pod niego contentu dopóki user nie zdecyduje (Content Engine
 * ma filter by status='active' w osobnym ticku — teraz to tylko flaga).
 */

import type {
  RepairRuleInput,
  RepairRuleResult,
  DemotedSeed,
  SeedStatus,
} from "@/types/mapRepair";

export function runR7(input: RepairRuleInput): RepairRuleResult {
  const operations: RepairRuleResult["operations"] = [];
  const ghostSeeds = input.auditReport.ghost_seeds ?? [];
  if (ghostSeeds.length === 0) {
    return {
      rule: "R7",
      operations: [],
      proposals: [],
      flags: [],
      skipped: [],
    };
  }

  const nodesBySeed = new Map<string, typeof input.nodes>();
  for (const n of input.nodes) {
    const list = nodesBySeed.get(n.seed_id) || [];
    list.push(n);
    nodesBySeed.set(n.seed_id, list);
  }
  const seedsById = new Map(input.seeds.map((s) => [s.id, s]));

  const demoted: DemotedSeed[] = [];

  for (const ghost of ghostSeeds) {
    const seed = seedsById.get(ghost.seed_id);
    if (!seed) continue;
    // Verify: 0 nodów tego seeda ma matched_wp_post_id
    const seedNodes = nodesBySeed.get(ghost.seed_id) || [];
    const matchedCount = seedNodes.filter((n) => n.matched_wp_post_id).length;
    if (matchedCount > 0) continue; // stale audit_report — skip safely
    if (seed.status && seed.status !== "active") continue; // already non-active

    const oldStatus: SeedStatus = (seed.status as SeedStatus) || "active";

    demoted.push({
      seed_id: ghost.seed_id,
      seed_name: ghost.seed_name,
      total_nodes: seedNodes.length,
      old_status: oldStatus,
    });

    operations.push({
      operation: "demote",
      payload: {
        rule: "R7",
        seed_id: ghost.seed_id,
        seed_name: ghost.seed_name,
        new_status: "pending_production",
      },
      rollback_payload: {
        seed_id: ghost.seed_id,
        old_status: oldStatus,
      },
    });
  }

  return {
    rule: "R7",
    operations,
    proposals: [],
    flags: [],
    skipped: [],
    // metadata for orchestrator summary
    // (demoted list inlined in payloads per operation)
  };
}
